import axios from 'axios';
import Vue from "vue";
import dict from './event-dict-osr.json';
export const $getJson = function (url,call,errorCall) {
  axios({
    method: 'get',
    url: url,
    dataType: "json",
    crossDomain: true,
    cache: false
  }).then(res => {
    call(res.data)
  }).catch(error => {
    errorCall(error);
  })
}
export const $loadFont = (name, url)=>{
  //name 字体名称
  //url  字体链接
  let style = document.createElement('style');
  style.type = 'text/css';
  style.innerText = '@font-face {font-family:' + name + ';src:url(' + url + ')};font-display: swap';
  document.getElementsByTagName('head')[0].appendChild(style);
}

function GetCurrDir(){
  var index = window.location.pathname.lastIndexOf('/');
  return window.location.origin+window.location.pathname.slice(0,index);
}
window.ha=function(send="send",action="action",code=null,leadsId=null){
  var data = null;
  code = "osr_"+code;
  if(GLOBAL_VARS.terminal=="chebaba"){
    gtmAnalytics.track({eventId:code});
  }
  else{
    for(var name in dict){
      if(dict[name].label==code){
        console.log(dict[name]);
        data = dict[name];
        break;
      }
    }
    try{
      dndcAnalytics('send', 'track', {
        eventId: data.eventId,
      });
    }
    catch(err){

    }
  }
}
window.track = function(event,info){
  try{
    var data;
    if(info){
      data = {
        eventId: event,
        eventInfo:info
      }
    }
    else{
      data = {
        eventId: event,
      }
    }
    dndcAnalytics('send', 'track',data)
  }
  catch (e) {
    console.log(e.toString());
  }
}

window.path = Vue.prototype.path = GLOBAL_VARS.online3D;

let defaultCarType = 'sylphy';
export const $urlValue = function (name) {
  return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ""])[1].replace(/\+/g, '%20')) || null
}
export const $isPC = function(){
  var userAgentInfo = navigator.userAgent;
  var Agents = ["Android", "iPhone",
    "SymbianOS", "Windows Phone",
    "iPad", "iPod"];
  var flag = true;
  for (var v = 0; v < Agents.length; v++) {
    if (userAgentInfo.indexOf(Agents[v]) > 0) {
      flag = false;
      break;
    }
  }
  return flag;
}
var carSeriesApi = "https://digital-official-api.dongfeng-nissan.com.cn/nissan/api/base/car-series";
export const getCarSeries = function(resolve,reject) {
  axios.get(carSeriesApi).then(res => {
    try {
      resolve(res.data)
    }catch (e) {
      reject(e);
    }
  })
}


